const KEY='fliplottery-customer-referral-v1';
const valid=code=>/^CR-[A-F0-9]{32}$/.test(code);
export function captureCustomerReferral(search,storage){
 const code=String(new URLSearchParams(search).get('customer_ref')||'').trim().toUpperCase();
 try {
  const target=storage||window.sessionStorage;
  const existing=target.getItem(KEY);if(existing&&valid(existing))return existing;
  if(valid(code))target.setItem(KEY,code);
 } catch (_) { /* Restricted browser storage must not break registration. Component state retains the code. */ }
 return !code?'':valid(code)?code:'INVALID';
}
export function clearCustomerReferral(storage){try{(storage||window.sessionStorage).removeItem(KEY);}catch(_) {}}
export const customerReferralLink=(code,origin)=>`${origin}/register?customer_ref=${encodeURIComponent(code)}`;
